import React from "react";
import { Container, Typography, Paper, Box } from "@mui/material";
import Layout from "../components/Layout";

const PrivacyPolicy: React.FC = () => {
  return (
    <Layout>
      <Container maxWidth={false} sx={{ paddingY: 10, backgroundColor: "#0f172a" }}>
        <Typography
          variant="h5"
          component="h1"
          align="center"
          sx={{
            marginBottom: 4,
            color: "#ffffff",
          }}
        >
          Our Privacy Policy
        </Typography>

        <Paper
          sx={{
            padding: 4,
            borderRadius: 2,
            boxShadow: 3,
            backgroundColor: "#ffffff",
            fontWeight: "600",
            color: "#374151",
          }}
        >
          <Typography variant="body1" paragraph>
            At Matt Scholar Solutions, we respect your privacy and are committed
            to protecting your personal information. This Privacy Policy outlines
            how we collect, use, and protect your personal data in accordance with
            applicable data protection laws and regulations.
          </Typography>

          {/* Unlimited Revisions Section */}
          <Typography variant="h6" sx={{ marginTop: 3, fontWeight: "bold", color: "#1e293b" }}>
            Free Unlimited Revisions
          </Typography>
          <Typography variant="body1" paragraph>
            We are dedicated to ensuring your satisfaction with our services. To achieve this,
            we offer free unlimited revisions for all orders. You can request as many changes
            as needed until the final deliverable meets your expectations, at no extra cost.
          </Typography>

          {/* Existing Sections */}
          <Typography variant="h6" sx={{ marginTop: 3, fontWeight: "bold", color: "#1e293b" }}>
            Collection of Personal Information
          </Typography>
          <Typography variant="body1" paragraph>
            We may collect personal information from you when you visit our website
            or use our services. This information may include your name, email
            address, phone number, company name, job title, and any other information
            that you voluntarily provide to us.
          </Typography>

          <Typography variant="h6" sx={{ marginTop: 3, fontWeight: "bold", color: "#1e293b" }}>
            Use of Personal Information
          </Typography>
          <Typography variant="body1" paragraph>
            We may use your personal information to provide you with our services,
            respond to your inquiries, send you marketing communications, and comply
            with applicable laws and regulations. We may also use your data to improve
            our services, particularly for assignment writing assistance and other
            educational services.
          </Typography>

          <Typography variant="h6" sx={{ marginTop: 3, fontWeight: "bold", color: "#1e293b" }}>
            Sharing of Personal Information
          </Typography>
          <Typography variant="body1" paragraph>
            We do not share your personal information with any third parties except
            as required by law or as necessary to provide you with our services. We may
            share your personal information with our service providers who assist us in
            providing our services to you.
          </Typography>

          <Typography variant="h6" sx={{ marginTop: 3, fontWeight: "bold", color: "#1e293b" }}>
            Data Security
          </Typography>
          <Typography variant="body1" paragraph>
            We take appropriate technical and organizational measures to ensure the
            security of your personal information. We store your personal information
            on secure servers and restrict access to it to authorized personnel only.
          </Typography>

          <Typography variant="h6" sx={{ marginTop: 3, fontWeight: "bold", color: "#1e293b" }}>
            Use of Cookies
          </Typography>
          <Typography variant="body1" paragraph>
            We use cookies to improve your browsing experience on our website. Cookies
            are small text files that are placed on your device when you visit our
            website. They help us to recognize your device and remember your preferences.
          </Typography>

          <Typography variant="h6" sx={{ marginTop: 3, fontWeight: "bold", color: "#1e293b" }}>
            Third-Party Websites
          </Typography>
          <Typography variant="body1" paragraph>
            Our website may contain links to third-party websites. We are not responsible
            for the content or privacy practices of these websites. We encourage you to
            review their privacy policies before providing them with any personal
            information.
          </Typography>

          <Typography variant="h6" sx={{ marginTop: 3, fontWeight: "bold", color: "#1e293b" }}>
            Changes to this Privacy Policy
          </Typography>
          <Typography variant="body1" paragraph>
            We reserve the right to make changes to this Privacy Policy at any time.
            Any changes we make will be posted on this page.
          </Typography>

          <Typography variant="h6" sx={{ marginTop: 3, fontWeight: "bold", color: "#1e293b" }}>
            Contact Us
          </Typography>
          <Typography variant="body1" paragraph>
            If you have any questions or concerns about our Privacy Policy or the way
            we handle your personal information, please contact us at{" "}
            <a href="mailto:matt@mattengg.com" style={{ color: "#1d4ed8", textDecoration: "underline" }}>
              info@mattengg.com
            </a>.
          </Typography>

          <Typography variant="body1" paragraph sx={{ marginTop: 4 }}>
            By using our website and services, you consent to the terms of this Privacy
            Policy.
          </Typography>
        </Paper>
      </Container>
    </Layout>
  );
};

export default PrivacyPolicy;
